import { render, staticRenderFns } from "./UserButtons.vue?vue&type=template&id=143fd778&scoped=true"
import script from "./UserButtons.vue?vue&type=script&lang=js"
export * from "./UserButtons.vue?vue&type=script&lang=js"
import style0 from "./UserButtons.vue?vue&type=style&index=0&id=143fd778&prod&lang=css"
import style1 from "./UserButtons.vue?vue&type=style&index=1&id=143fd778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143fd778",
  null
  
)

export default component.exports